import jimp from "jimp";

export const fileToBase64 = file => {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = error => {
      reject(error);
    };
  });
};

export const resizeImage = async (imageUrl, maxWidth, maxHeight) => {
  const image = await jimp.read(imageUrl);
  const dimensions = await getImageDimensionsAsync(imageUrl);
  if (dimensions.width > maxWidth || dimensions.height > maxHeight) {
    const orientation = getImageOrientation(dimensions);
    const params =
      orientation == "landscape" || orientation == "square"
        ? { w: maxWidth, h: jimp.AUTO }
        : { w: jimp.AUTO, h: maxHeight };

    await setImageDimensionsAsync(image, params.w, params.h);
  }

  return await jimpToBlobAsync(image);
};

const getImageDimensionsAsync = imageUrl => {
  return new Promise(function(resolve, reject) {
    const img = new Image();
    img.onload = function() {
      resolve({ width: this.width, height: this.height });
    };
    img.onerror = function(error) {
      reject(error);
    };
    img.src = imageUrl;
  });
};

const getImageOrientation = ({ width, height }) => {
  if (width > height) return "landscape";
  if (width < height) return "portrait";
  return "square";
};

const setImageDimensionsAsync = async (jimpImage, width, height) => {
  return new Promise(resolve => {
    jimpImage.resize(width, height, resolve(jimpImage));
  });
};

const jimpToBlobAsync = async jimpImage => {
  const buffer = await jimpImage.getBufferAsync(jimpImage._originalMime);
  return new Blob([buffer], { type: jimpImage._originalMime });
};
